import { createAsyncThunk } from '@reduxjs/toolkit';

import type { ICourse, ICourseCategory } from '@/Module/Lesson/Model/DataModel';
import { LessonService } from '@/Module/Lesson/Service';

export const getCourseCategoryByCourseIdAction = createAsyncThunk<ICourseCategory[], ICourse['id']>(
  'lesson/getCourseCategoryByCourseId',
  async (lessonId, { signal }) => {
    return LessonService.getCourseCategoryByCourseId(lessonId, signal).then(({ data: { data } }) => data);
  },
);
